// src/components/FAQSection.js
import React, { useState } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPlus, FaMinus } from 'react-icons/fa';

const Section = styled.section`
  text-align: center;
  background-color: var(--bg-surface);
  backdrop-filter: blur(10px);
`;

const SectionTitle = styled(motion.h2)`
  font-size: 2.8rem;
  margin-bottom: 3rem;
`;

const FAQContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  text-align: left;
`;

const FAQItem = styled.div`
  border-bottom: 1px solid var(--border-color);
  margin-bottom: 1rem;
`;

const Question = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.2rem; // Thori zyada padding
  cursor: pointer;
  font-size: 1.2rem;
  font-weight: 600;
  border-radius: 8px; // Rounded corners for hover effect
  transition: background-color 0.3s ease; // Smooth transition
  &:hover {
    background-color: rgba(61, 90, 254, 0.1);
  }
`;

const Answer = styled(motion.div)`
  overflow: hidden;
  color: var(--text-secondary-color);
  padding-right: 1rem;
`;

// --- YEH DATA HUMNE UPDATE KIYA HAI ---
const faqData = [
  { 
    q: "What are the key features of the Trend Genie app?", 
    a: "The app provides a suite of powerful tools for trading, including: 1) Real-time market data, 2) Advanced and customizable charting tools, 3) AI-powered insights to identify potential opportunities, and 4) Personalized watchlists to track assets that matter to you." 
  },
  { 
    q: "Is this app suitable for beginners?", 
    a: "Yes, absolutely. While our tools are powerful enough for seasoned traders, the interface is designed to be intuitive and user-friendly. Our AI-generated insights help simplify complex market data, making it easier for beginners to make informed decisions." 
  },
  { 
    q: "How does the Trend Genie AI analysis work?", 
    a: "Our AI leverages advanced machine learning models to analyze vast amounts of market data, including historical performance, price movements, and key indicators. It identifies patterns and trends to provide predictive insights that can help you stay ahead of the curve." 
  },
  { 
    q: "Where can I download the app?", 
    a: "Currently, the Trend Genie app is available for Android devices on the Google Play Store. An iOS version is planned for future release." 
  },
  { 
    q: "What is the 'Future Vision for Web3'?", 
    a: "Our Web3 vision, codenamed 'Project Sentinel', is an AI-powered platform currently in development. It is being built to automatically analyze crypto whitepapers to provide a data-driven feasibility score and detect potential scams, bringing much-needed transparency to the digital asset market." 
  },
  { 
    q: "When will the Web3 platform be available?", 
    a: "The Web3 platform is under active development according to our official roadmap. We are currently in the foundational phase. For the latest updates and a detailed timeline, please visit our 'Our Vision' page." 
  }
];

const FAQSection = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = index => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <Section>
            <SectionTitle initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}>
                Your Questions, Answered
            </SectionTitle>
            <FAQContainer>
                {faqData.map((item, index) => (
                    <FAQItem key={index}>
                        <Question onClick={() => toggleFAQ(index)}>
                            {item.q}
                            <span>{activeIndex === index ? <FaMinus /> : <FaPlus />}</span>
                        </Question>
                        <AnimatePresence>
                            {activeIndex === index && (
                                <Answer
                                    initial={{ opacity: 0, height: 0 }}
                                    animate={{ opacity: 1, height: 'auto' }}
                                    exit={{ opacity: 0, height: 0 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    <p style={{paddingBottom: '1rem'}}>{item.a}</p>
                                </Answer>
                            )}
                        </AnimatePresence>
                    </FAQItem>
                ))}
            </FAQContainer>
        </Section>
    );
};

export default FAQSection;